import { jsx as _jsx } from "react/jsx-runtime";
import { HiChevronLeft } from "react-icons/hi2";
import cn from "classnames";
const SwiperButton = ({ isNext, className, swiper }) => {
    return (_jsx("button", { className: cn(className), onClick: () => {
            isNext ? swiper.slideNext() : swiper.slidePrev();
        }, children: _jsx(HiChevronLeft, { className: cn("swiper-btn", isNext && "swiper-btn--next") }) }));
};
export default SwiperButton;
